import type { Resource } from '../../';
export const country_countries_BG: Resource = {"default":"Bulgaria"};
